import React, { useState, useEffect } from 'react';
import { useParams } from 'react-router-dom';
import {
  Box,
  Typography,
  Paper,
  CircularProgress
} from '@mui/material';
import AIOrchestratorStats from '../../../components/admin/ai-orchestrator/AIOrchestratorStats';
import { useSnackbar } from 'notistack';
import aiOrchestratorService from '../../../services/aiOrchestratorService';

const AIOrchestratorStatsPage = () => {
  const { id } = useParams();
  const { enqueueSnackbar } = useSnackbar();
  const [stats, setStats] = useState(null);
  const [loading, setLoading] = useState(true);

  const fetchStats = async () => {
    try {
      const response = await aiOrchestratorService.getStatistics(id);
      setStats(response.data);
      setLoading(false);
    } catch (error) {
      enqueueSnackbar('Failed to fetch statistics', { variant: 'error' });
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchStats();
    // Refresh stats every 30 seconds
    const interval = setInterval(fetchStats, 30000);
    return () => clearInterval(interval);
  }, [id]);

  if (loading) {
    return (
      <Box sx={{ display: 'flex', justifyContent: 'center', alignItems: 'center', height: '100vh' }}>
        <CircularProgress />
      </Box>
    );
  }

  return (
    <Box sx={{ p: 3 }}>
      <Typography variant="h5" gutterBottom>
        Orchestrator Statistics
      </Typography>
      <Paper sx={{ mt: 3 }}>
        <AIOrchestratorStats stats={stats} />
      </Paper>
    </Box>
  );
};

export default AIOrchestratorStatsPage; 